// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"517f5069","455":"7cd2d699"}[chunkId] + ".chunk.js";
};